module.exports = __webpack_public_path__ + "img/barlogo-1.08f6a7c1.png";